import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    qrCodeInfo: {
      wechat: '',
      qq: ''
    }
  },
  mutations: {
    setQrcodeInfo(state, payload) {
      state.qrCodeInfo = payload;
    }
  },
  actions: {
    info({ commit }) {
      api.getQrCodeInfo().then(({ data }) => {
        commit('setQrcodeInfo', data);
      });
    },
    update(context, data) {
      return api.updateQrCodeInfo(data);
    }
  }
};

appStore.registerModule('qrcodes', store);
